import { useNavigate } from "react-router-dom";
import { Users, Bell, Building2, Tag, MailCheck, Activity, MapPin, MessagesSquare, FileSpreadsheet } from "lucide-react";
import Layout from "../components/Layout";
import { useAuth } from "../hooks/useAuth";

const ALL_LINKS = [
  { icon: Users, title: "Gebruikersbeheer", desc: "Gebruikers en hun rollen beheren", to: "/gebruikersbeheer", roles: ["admin", "kam", "partner_admin"] },
  { icon: Bell, title: "Alertering", desc: "Meldingen per gebruiker instellen", to: "/alert-regels", roles: ["admin"] },
  { icon: Building2, title: "Partnerbeheer", desc: "Partners en hun vestigingen beheren", to: "/partnerbeheer", roles: ["admin"] },
  { icon: Tag, title: "Functiesuggesties", desc: "Autofill-suggesties voor de functietitel", to: "/functietitels", roles: ["admin"] },
  { icon: MailCheck, title: "Mail goedkeuring", desc: "E-mails goedkeuren voor je partners en hiring managers", to: "/mail-goedkeuring", roles: ["admin", "kam"] },
  { icon: MapPin, title: "Toegangsverzoeken", desc: "Verzoeken om toegang tot een vestiging beoordelen", to: "/toegangsverzoeken", roles: ["admin", "kam", "partner_admin"] },
  { icon: MessagesSquare, title: "Gesprekken", desc: "Alle chats tussen partners en Waves meelezen", to: "/gesprekken", roles: ["admin"] },
  { icon: FileSpreadsheet, title: "Sheets-synchronisatie", desc: "Wat elke Google Sheets-sync heeft gewijzigd, en de fouten", to: "/sheets-sync", roles: ["admin"] },
  { icon: Activity, title: "Systeemstatus", desc: "Technische status van backend, database en integraties", to: "/systeemstatus", roles: ["admin"] },
];

export default function Beheer() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const links = ALL_LINKS.filter(link => user?.role && link.roles.includes(user.role));

  return (
    <Layout title="Beheer" subtitle="Alle beheerpagina's op één plek">
      <div className="mx-auto grid max-w-[1240px] grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3">
        {links.map(link => (
          <button
            key={link.to}
            onClick={() => navigate(link.to)}
            className="group flex items-start gap-4 rounded-card border border-waves-line bg-white p-6 text-left transition-[transform,box-shadow] duration-150 hover:-translate-y-1 hover:shadow-lift"
          >
            <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-nav bg-waves-mist">
              <link.icon size={19} />
            </div>
            <div className="min-w-0 flex-1">
              <div className="text-base font-bold">{link.title}</div>
              <div className="mt-1 text-sm text-waves-muted">{link.desc}</div>
            </div>
            <span className="text-waves-muted transition-colors group-hover:text-waves-ink">→</span>
          </button>
        ))}
      </div>
    </Layout>
  );
}
